import { render } from "./TrainingEvaluations.vue?vue&type=template&id=1bc74f4c&scoped=true"
import script from "./TrainingEvaluations.vue?vue&type=script&lang=js"
export * from "./TrainingEvaluations.vue?vue&type=script&lang=js"

import "./TrainingEvaluations.vue?vue&type=style&index=0&id=1bc74f4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc74f4c"]])

export default __exports__